import * as AuthAPI from "pages/signin/services";
import { getProfile } from "pages/signin/services";
import { useSetRecoilState } from "recoil";
import { defaultUserProfile, userProfile, userToken } from "recoil/atom";
import { setSession, setSessionInfo } from "utils/sessions";
import { useNavigate } from "react-router-dom";

export default function useAuth() {
  const setUserProfile = useSetRecoilState(userProfile);
  const setUserToken = useSetRecoilState(userToken);
  const navigate = useNavigate();

  const login = async (loginInfo) => {
    const res = await AuthAPI.login(loginInfo);
    const { user, accessToken } = res.data;
    if (!accessToken && user.security.is2faEnabled) {
      setUserProfile({
        user,
        isAuthenticated: false,
        isInitialize: false,
      });
    } else {
      // setUserProfile({
      //   user,
      //   isAuthenticated: true,
      //   isInitialize: true,
      // });
      setUserToken(accessToken);
      setSession(accessToken);
      setSessionInfo(user);
      await getMerchantProfile();
      navigate("/dashboard/payments", { replace: true });
    }
  };

  const logout = async () => {
    setSession(null);
    setSessionInfo(null);
    setUserProfile(defaultUserProfile);
    setUserToken(undefined);
    navigate("/signin", { replace: true });
  };

  const resetPassword = async (values) => {
    await AuthAPI.resetPassword(values);
  };

  const changeNewPassword = async (values) => {
    await AuthAPI.changeNewPassword(values);
  };

  const getMerchantProfile = async () => {
    try {
      const res = await getProfile();
      setUserProfile({
        user: res.data,
        isAuthenticated: true,
        isInitialize: true,
      });
    } catch (err) {
      setUserProfile({
        user: undefined,
        isAuthenticated: false,
        isInitialize: true,
      });
    }
  };

  return { login, logout, resetPassword, changeNewPassword, getMerchantProfile };
}
